import { createSlice } from "@reduxjs/toolkit";
import { fetchWebRoles } from "../api.ts";
import { initialStateWeb, RoleStatus } from "../constants.ts";

const initialState = initialStateWeb;

export const webRolesSlice = createSlice({
  name: "web",
  initialState,
  reducers: {
    prevPage: (state) => {
      if (state.currentPage > 1) state.currentPage = state.currentPage - 1;
    },
    nextPage: (state) => {
      if (state.next) state.currentPage = state.currentPage + 1;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setSort: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload ?? "";
    },
    setSubcompanyId: (state, action) => {
      state.subcompany_id = action.payload ?? null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebRoles.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchWebRoles.fulfilled, (state, action) => {
        if (state.status == RoleStatus.All)
          state.data.all = action.payload?.results;
        else if (state.status == RoleStatus.Active)
          state.data.active = action.payload?.results;
        else if (state.status == RoleStatus.Inactive)
          state.data.inactive = action.payload?.results;
        else if (state.status == RoleStatus.Draft)
          state.data.draft = action.payload?.results;
        state.count = action?.payload.count;
        state.next = action?.payload.next;
        state.prev = action?.payload.prev;
        state.loading = false;
      })
      .addCase(fetchWebRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.error as string) || "Error found";
      });
  },
});

export const { prevPage, nextPage, setPage, setPageSize, setStatus, setSort, setSearch, setSubcompanyId } =
  webRolesSlice.actions;

export default webRolesSlice.reducer;
